import { DeferredPromise } from '@Tools/DeferredPromise';

export class LeaveCondition<E extends string> extends DeferredPromise {
    public name: string;
    public gameState: E | undefined;
    public gameSubState: E | undefined;

    constructor(name: string, gameState?: E, gameSubState?: E) {
        super();
        this.name = name;
        this.gameState = gameState;
        this.gameSubState = gameSubState;
    }
}
